import {
    FORMAT_OPTIONS,
    IDENTIFIER_OPTIONS,
    LENGTH_OPTIONS,
    // NoteSwitchInput,
    NoteTemplateInput,
    NoteToggleInput,
    TreatmentApproachesInput,
} from '@/features/practice/edit-notes-settings';
import { SettingsSection } from '@/widgets/settings/settings-section';

export function SessionNoteSettingsForEhr() {
    return (
        <>
            <SettingsSection title="Progress notes" className="mb-12">
                <NoteTemplateInput />
                <TreatmentApproachesInput />
                {/* Hidden until insurance-focused features are built; the stored values are kept.
                https://linear.app/nessoapp/issue/NSS-654/hide-the-90837-justification-and-diagnosis-codes-options-from-the
                <NoteSwitchInput
                    field="includeCpt90837Justification"
                    label="Include 90837 justification"
                />
                <NoteSwitchInput field="includeDiagnosisCodes" label="Include diagnosis codes" />
                */}
            </SettingsSection>
            <SettingsSection title="AI preferences">
                <NoteToggleInput field="noteFormat" label="Format" options={FORMAT_OPTIONS} />
                <NoteToggleInput field="noteLength" label="Length" options={LENGTH_OPTIONS} />
                <NoteToggleInput
                    field="identifier"
                    label="Identifier"
                    options={IDENTIFIER_OPTIONS}
                />
            </SettingsSection>
        </>
    );
}
